import React from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import "swiper/swiper.scss";
import "swiper/modules/pagination/pagination.scss";
import "swiper/modules/navigation/navigation.scss";
import { Pagination, Navigation } from "swiper";
import {
  Theme0,
  Theme1,
  Theme2,
  Theme3,
  Theme4,
  Theme5,
  Theme6,
  Theme7,
  Theme8,
  Theme9,
  Theme10,
} from "../../../assets/images/themes";
import "./ThemeSlider.css";
import useWindowSize from "../../../helpers/getWindowSize";
import { message } from "antd";
import { useSelector } from "react-redux";
import {
  DEVELOPER,
  SUPER_ADMIN,
  SUPER_ADMIN_EDITOR,
} from "../../../config/roles";
import { AiFillCheckCircle } from "react-icons/ai";
const ThemeSlider = ({ selectedTheme, setSelectedTheme }) => {
  const { subscribedPlan } = useSelector((state) => state.membership);
  const { role } = useSelector((state) => state.auth.user);
  const { width } = useWindowSize();
  const numberOfSildesPerview = () => {
    if (width <= 300) return 1;
    else if (width > 300 && width <= 800) return 2;
    else if (width > 800 && width <= 1200) return 2;
    else if (width > 1200 && width <= 1700) return 3;
    else return 4;
  };

  const handleThemeSwitch = (index) => {
    if (
      subscribedPlan?.paymentStatus === "SUCCESS" ||
      role === SUPER_ADMIN ||
      role === SUPER_ADMIN_EDITOR ||
      role === DEVELOPER
    ) {
      setSelectedTheme(index);
    } else {
      message.error("This is premium feature, buy subscription");
    }
  };
  const THEMES = [
    Theme0,
    Theme1,
    Theme2,
    Theme3,
    Theme4,
    Theme5,
    Theme6,
    Theme7,
    Theme8,
    Theme9,
    Theme10,
  ];
  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Swiper
        slidesPerView={numberOfSildesPerview()}
        spaceBetween={20}
        slidesPerGroup={3}
        loopFillGroupWithBlank={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        {THEMES.map((item, index) => {
          return (
            <SwiperSlide>
              <div
                className="slider_image_container"
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  handleThemeSwitch(index);
                }}
              >
                <img
                  src={item}
                  alt=""
                  className="slider_image"
                  style={{
                    filter:
                      selectedTheme === index ? "blur(1.2px)" : "blur(0px)",
                  }}
                />
                {selectedTheme === index && (
                  <div
                    style={{
                      display: "flex",
                      position: "absolute",
                      bottom: 20,
                      backgroundColor: "white",
                      padding: 5,
                      borderRadius: 20,
                    }}
                  >
                    <AiFillCheckCircle size={20} />
                  </div>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ThemeSlider;
